import { useContext, useEffect, useRef, useState } from "react";
import { GetCertificadoRework } from "../../../../../hooks/getEncuesta";
import { useLoading } from "../../../../../components/Loading/useLoading";
import { useSnackbar } from "notistack";
import { GetAllStandarsList } from "../../../../../hooks/getStandarsList";
import { ThemeContext } from "@emotion/react";
import { Backdrop, Box, Button, Checkbox, Fade, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import { CertificadoPregunta } from "./pregunta";
import { UpdateCuestionarioRework } from "../../../../../hooks/cuestionarios";
import { Delete } from "@mui/icons-material";

const TIPO_REPETICION = [
  { label: 'Turno', value: 1 },
  { label: 'Semanal', value: 2 },
]

export const ModalCertificadoEdit = ({ open, setOpen, id_cues }) => {

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    maxWidth: 1000,
    minWidth: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    pt: 3,
    display: 'flex',
    justifyContent: 'center',
    maxHeight: 550,
    overflowY: 'scroll'
  };

  const formCert = useRef(null);
  const theme = useContext(ThemeContext);
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { getAllStandarsListMutation } = GetAllStandarsList();
  const { getCertificadoReworkMutation } = GetCertificadoRework();
  const { updateCuestionarioReworkMutation } = UpdateCuestionarioRework();
  const [encuesta, setEncuesta] = useState(null);
  const [secciones, setSecciones] = useState([]);
  const [preguntas, setPreguntas] = useState([]);
  const [errorName, setErrorName] = useState(false);
  const [standars, setStandars] = useState([]);
  const [repeticion, setRepeticion] = useState(null);
  const [diasSemana, setDiasSemana] = useState([]);

  const getEncuesta = async () => {
    setAppLoading(true);
    getCertificadoReworkMutation(id_cues, {
      onSuccess: (data) => {
        let encuesta = data.data.cuestionario;
        setEncuesta(encuesta);
        setRepeticion(encuesta.cues_tipo_repeticion);
        setDiasSemana(JSON.parse(encuesta.cues_dias_semana) || []);
        let secc = data.data.secciones;
        secc.map(s => {
          s.delete = false
          s.cuestionarios_preguntas.map(p => {
            p.delete = false
          })
        })
        let newSeccions = secc.map(({ cuestionarios_preguntas, ...rest }) => ({
          ...rest,
          preguntas: cuestionarios_preguntas
        }));
        setSecciones(newSeccions);
        let preg = data.data.preguntas;
        preg.map(p => {
          p.delete = false
        })
        setPreguntas(preg);
      },
      onError: () => { setEncuesta(null) },
      onSettled: () => { setAppLoading(false) }
    })
  }
  const getStandars = () => {
    getAllStandarsListMutation({}, {
      onSuccess: (data) => {
        setStandars(data);
      },
      onError: (error) => {
        console.log(error);
      }
    })
  }
  const updateEncuesta = (body) => {
    setAppLoading(true);
    updateCuestionarioReworkMutation({ id: id_cues, body }, {
      onSuccess: (data) => {
        enqueueSnackbar("Certificado actualizado con exito", {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: (error) => {
        enqueueSnackbar("Error al actualizar el certificado", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
        handleClose();
      }
    })
  }

  useEffect(() => {
    if (id_cues !== null && open) {
      getEncuesta();
      getStandars();
    }
  }, [open]);

  const validateSecciones = () => {
    if (secciones.length > 0) {
      let exist_null = secciones.some(seccion => {
        return seccion.preguntas.some((preg) => {
          return preg.cupe_tipo === null || preg.stand_id === undefined;
        })
      })

      return exist_null;
    }
    return false;
  }
  const validatePreguntas = () => {
    if (preguntas.length > 0) {
      let exist_null = preguntas.some((preg) => {
        return preg.cupe_tipo === null || preg.stand_id === undefined;
      })
      return exist_null;
    }
    return false;
  }
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let validate_secciones = validateSecciones();
    let validate_preguntas = validatePreguntas();
    if (validate_secciones || validate_preguntas) {
      return false;
    } else {
      let cuestionario = {
        cues_id: id_cues,
        cues_nombre: formCert.current.cues_nombre.value,
        cues_descripcion: formCert.current.cues_descripcion.value,
        cues_tipo_repeticion: repeticion,
        cues_frecuencia_turno: repeticion === 1 ? +formCert.current.cues_frecuencia_turno.value : null,
        cues_dias_semana: repeticion === 2 ? JSON.stringify(diasSemana) : null,
      }
      let seccionesData = [...secciones];
      let preguntasData = [...preguntas];
      let body = {
        cuestionario,
        preguntas: preguntasData,
        secciones: seccionesData
      }
      updateEncuesta(body);
    }
  }

  const onChangeWeekDays = (weekday) => {
    let diasTemp = [...diasSemana];
    if (diasTemp.includes(weekday)) {
      diasTemp = diasTemp.filter(dia => dia !== weekday);
    } else {
      diasTemp.push(weekday);
    }
    setDiasSemana(diasTemp);
  }

  const addSeccion = () => {
    let preg = [...preguntas];
    console.log(preg);
    let seccion = {
      cuse_nombre: null,
      cuse_descripcion: null,
      preguntas: preg,

    }
    console.log(seccion);
    setSecciones([...secciones, seccion]);
    setPreguntas([]);
  }

  const changeDataSeccion = (index, field, value) => {
    let seccionesTemp = [...secciones];
    seccionesTemp[index][field] = value;
    setSecciones(seccionesTemp);
  }

  const changeDataPregunta = (indexSeccion, indexPregunta, field, value) => {
    if (indexSeccion === null) {
      let preguntasTemp = [...preguntas];
      preguntasTemp[indexPregunta][field] = value;
      setPreguntas(preguntasTemp);
    } else {
      let seccionesTemp = [...secciones];
      seccionesTemp[indexSeccion].preguntas[indexPregunta][field] = value;
      setSecciones(seccionesTemp);
    }
  }

  const addPregunta = () => {
    let pregunta = {
      cupe_pregunta: null,
      cupe_descripcion: null,
      cupe_tipo: null,
      cupe_multiple: false,
      cupe_opciones: null,
      cupe_valorprellenado: null,
      stand_id: null,
      delete: false
    }
    if (secciones.length === 0) {
      setPreguntas([...preguntas, pregunta]);
    } else {
      let seccionesTemp = [...secciones];
      seccionesTemp[seccionesTemp.length - 1].preguntas.push(pregunta);
      setSecciones(seccionesTemp);
    }
  }
  const addPreguntaSeccion = (indexSeccion) => {
    let pregunta = {
      cupe_pregunta: null,
      cupe_descripcion: null,
      cupe_tipo: null,
      cupe_multiple: false,
      cupe_opciones: null,
      cupe_valorprellenado: null,
      stand_id: null,
      delete: false
    }
    let seccionesTemp = [...secciones];
    seccionesTemp[indexSeccion].preguntas.push(pregunta);
    setSecciones(seccionesTemp);
  }
  const deletePregunta = (indexPregunta, indexSeccion) => {
    if (secciones.length === 0) {
      let preguntasTemp = [...preguntas];
      preguntasTemp[indexPregunta].delete = true;
      setPreguntas(preguntasTemp);
    } else {
      let seccionesTemp = [...secciones];
      seccionesTemp[indexSeccion].preguntas[indexPregunta].delete = true;
      setSecciones(seccionesTemp);
    }
  }

  const deleteSeccion = (index) => {
    let seccionesTemp = [...secciones];
    seccionesTemp[index].delete = true;
    setSecciones(seccionesTemp);
  }

  const handleClose = () => {
    setPreguntas([]);
    setSecciones([]);
    setRepeticion(null);
    setDiasSemana([]);
    setErrorName(false);
    setOpen(false);
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <form ref={formCert} onSubmit={onSubmit}>
            <Grid container spacing={0}>
              <Grid item xs={12} sx={{ p: 0, textAlign: 'center' }} >
                <Typography id="transition-modal-title" variant="h6" component="h2">
                  Nuevo Check de Línea
                </Typography>
              </Grid>
              <Grid item xs={6} sx={{ p: 2, mt: 2, textAlign: 'start' }} >
                <TextField
                  id="cues_nombre"
                  label="Nombre del Check de Línea"
                  name="  cues_nombre"
                  size="small"
                  fullWidth
                  required
                  onChange={(e) => {
                    e.target.value.length > 0 ?
                      setErrorName(false) :
                      setErrorName(true)
                  }}
                  sx={{ color: theme.palette.primary.input }}
                  defaultValue={encuesta?.cues_nombre}
                  error={errorName}
                  helperText={errorName ? 'Ingrese un valor' : ''}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <TextField
                  id="cues_descripcion"
                  label="Descripción del Check de Línea"
                  name="cues_descripcion"
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  defaultValue={encuesta?.cues_descripcion}
                  sx={{ color: theme.palette.primary.input }}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <TextField
                  id="cues_observaciones"
                  label="Observaciones"
                  name="cues_observaciones"
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  defaultValue={encuesta?.cues_observaciones}
                  sx={{ color: theme.palette.primary.input }}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 2, textAlign: 'left' }} >
                <Typography id="transition-modal-title" variant="h8" component="h3">
                  Frecuencia
                </Typography>
              </Grid>
              <Grid item xs={6} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <FormControl fullWidth required error={repeticion === null}>
                  <InputLabel id="tipo_repeticion_label" ></InputLabel>
                  <Select
                    labelId={`tipo_repeticion_label`}
                    id={`tipo_repeticion`}
                    name={`tipo_repeticion`}
                    label={`Tipo de repetición`}
                    required
                    size="small"
                    fullWidth
                    value={repeticion}
                    onChange={(e) => {
                      setRepeticion(e.target.value);
                      setDiasSemana([]);
                    }}
                    error={repeticion === null}
                  // sx={{ color: theme.palette.primary.input }}
                  >
                    {
                      TIPO_REPETICION.map((option) => (
                        <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                      ))
                    }
                  </Select>
                  <FormHelperText>{repeticion === null ? 'Seleccione un tipo de repetición' : ''}</FormHelperText>
                </FormControl>
              </Grid>
              {
                repeticion === 1 && (
                  <Grid item xs={6} sx={{ p: 2, mt: -2, textAlign: 'start' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', height: '100%' }}>
                      <Typography id="transition-modal-title" variant="h8" component="h4" sx={{ m: 0, p: 0 }}>
                        Veces por turno:
                      </Typography>
                      <TextField
                        id="cues_frecuencia_turno"
                        name="cues_frecuencia_turno"
                        label=""
                        type="number"
                        size="small"
                        required
                        inputProps={{ min: 1, max: 5 }}
                        defaultValue={encuesta?.cues_frecuencia_turno}
                        sx={{ color: theme.palette.primary.input }}
                      />
                    </div>
                  </Grid>
                )
              }
              {
                repeticion === 2 && (
                  <Grid item xs={6} sx={{ p: 2, mt: -2, textAlign: 'start' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', height: '100%' }}>
                      <Typography id="transition-modal-title" variant="h8" component="h4" sx={{ m: 0, p: 0 }}>
                        Dias de la semana:
                      </Typography>
                      <FormGroup row>
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(1)} onChange={(e) => onChangeWeekDays(1)} />} label="L" />
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(2)} onChange={(e) => onChangeWeekDays(2)} />} label="M" />
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(3)} onChange={(e) => onChangeWeekDays(3)} />} label="M" />
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(4)} onChange={(e) => onChangeWeekDays(4)} />} label="J" />
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(5)} onChange={(e) => onChangeWeekDays(5)} />} label="V" />
                      </FormGroup>
                    </div>
                  </Grid>
                )
              }
              {
                secciones && secciones.map((seccion, index) => (
                  <>
                    {
                      !seccion.delete && (
                        <div key={`sec_${index}`} style={{ width: '100%' }}>
                          <Grid item xs={12} sx={{ p: 2, textAlign: 'start', display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                            <Typography id="transition-modal-title" variant="h8" component="h4">
                              Sección {index + 1}
                            </Typography>
                            <IconButton
                              size="large"
                              sx={{ ml: 1 }}
                              onClick={() => deleteSeccion(index)}>
                              <Delete sx={{ fontSize: 25 }} />
                            </IconButton>
                          </Grid>
                          <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                            <TextField
                              id={`cuse_nombre_${index}`}
                              label="Nombre de sección"
                              name={`cuse_nombre_${index}`}
                              size="small"
                              fullWidth
                              required
                              sx={{ color: theme.palette.primary.input }}
                              defaultValue={seccion.cuse_nombre}
                              onChange={(e) => changeDataSeccion(index, "cuse_nombre", e.target.value)}
                              error={seccion?.cuse_nombre === null || seccion?.cuse_nombre === ''}
                              helperText={seccion?.cuse_nombre === null || seccion?.cuse_nombre === '' ? 'Ingrese un valor' : ''}
                            />
                          </Grid>
                          <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                            <Button variant="contained"
                              className="btn_system"
                              onClick={() => addPreguntaSeccion(index)}
                            >
                              Nueva Pregunta
                            </Button>
                          </Grid>
                          {
                            seccion.preguntas && seccion.preguntas.map((pregunta, indexPregunta) => (
                              <>
                                {
                                  !pregunta.delete && (
                                    <CertificadoPregunta
                                      key={`sec_${index}_pre_${indexPregunta}`}
                                      pregunta={pregunta}
                                      index={indexPregunta}
                                      padding={4}
                                      indexSeccion={index}
                                      changeDataPregunta={changeDataPregunta}
                                      standars={standars}
                                      deletePregunta={deletePregunta}
                                    />
                                  )
                                }
                              </>
                            ))
                          }
                        </div>
                      )
                    }
                  </>
                ))
              }
              {
                preguntas && preguntas.map((pregunta, index) => (
                  <>
                    {
                      !pregunta.delete && (
                        <CertificadoPregunta
                          key={`ns_pre_${index}`}
                          pregunta={pregunta}
                          index={index}
                          padding={4}
                          indexSeccion={null}
                          changeDataPregunta={changeDataPregunta}
                          standars={standars}
                          deletePregunta={deletePregunta}
                        />
                      )
                    }
                  </>
                ))
              }
              <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <Button variant="contained"
                  className="btn_system"
                  onClick={addSeccion}
                  disabled={secciones?.length > 0 && secciones[secciones?.length - 1]?.cuestionarios_preguntas?.length === 0}
                >
                  Nueva Sección
                </Button>
              </Grid>
              {
                secciones?.length === 0 && (
                  <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                    <Button variant="contained"
                      className="btn_system"
                      onClick={addPregunta}
                    >
                      Nueva Pregunta
                    </Button>
                  </Grid>
                )
              }
              <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <Button variant="contained"
                  className="btn_system"
                  type="submit"
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Fade>
    </Modal>
  );
}